import React from "react";
import "../../Restrictions/RestrictionsBanner/RestrictionsBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const EventWebinarBanner = ({ onLoad }) => {
  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div className="">
            <div
              className="container-fluid ctm-banner position-relative p-0"
              style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
            >
              <img
                src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/13.%20Event%20Webinars.webp"
                alt="Event Webinar Banner"
                className="w-100"
                loading={useHighRes ? "eager" : "lazy"}
                onLoad={handleImageLoad}
                fetchpriority={useHighRes ? "high" : "auto"}
              />
              {imageLoaded ? (
                <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
                  <p className="fs4 text-uppercase busy">Stay Informed</p>
                  <h1 className="banner-headings w-100">
                    Stay Ahead with <br /> Blueberry Webinars
                  </h1>
                  <div className="d-flex common-second-content">
                    <div className="ornge-border"></div>
                    <div className="second-content">
                      What’s the next big trend in business travel? Discover new
                      opportunities, learn from top experts, and expand your
                      network through our dynamic webinars and events.
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {imageLoaded ? (
              <div className="container why-staying px-lg-5 px-md-3">
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="headings">
                      <span>Want to</span> Connect with Our Industry Experts{" "}
                      <span
                        className="text-dark"
                        style={{ fontWeight: "bold" }}
                      >
                        ?
                      </span>
                    </h1>
                    <p className="mt-2">
                      Attend our webinars to gain exclusive insights from our
                      industry leaders. Whether you're planning your next trip
                      or optimizing your travel strategy, we've got you covered!
                    </p>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </BannerWrapper>

      {/* .......................After Banner Section........................... */}
    </>
  );
};

export default EventWebinarBanner;
